// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"a43c1fd7","453":"7a5c943b","934":"fbb2eaa1"}[chunkId] + ".chunk.js";
};